import {
  Badge,
  Box,
  Divider,
  Fade,
  Grid,
  Paper,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import { PDFExport } from "@progress/kendo-react-pdf";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import {
  fetchedPublicProfileDetailsApi,
  fetchedReviewApi,
  freelancerApi,
} from "../API/Api";
import useChatBot from "../Custom Hooks/useChatBot";
import Review from "../ServiceList Components/ServiceDetails/Review/Review";
import Reviewer from "../ServiceList Components/ServiceDetails/Reviewer/Reviewer";
import FloatingInfo from "./FloatingInfo";
import Accounts from "./LeftComponents/Accounts";
import BasicInfo from "./LeftComponents/BasicInfo";
import OfficeLocation from "./LeftComponents/OfficeLocation";
import PageReach from "./LeftComponents/PageReach";
import Schedule from "./LeftComponents/Schedule";
import Skills from "./LeftComponents/Skills";
import ProfileCard from "./ProfileCard";
import Jobs from "./RightComponents/Jobs";
import Offers from "./RightComponents/Offers";
import Portfolios from "./RightComponents/Portfolios";
import Services from "./RightComponents/Services";

// Adjust this path to wherever tokens.js actually lives in your tree.
import { tokens } from "../../store/tokens";
const ProfileDetails = (props) => {
  const profileRef = useRef(null);
  const { sopnoId } = useParams();
  const [profileDetails, setProfileDetails] = useState({});
  const [userServiceList, setUserServiceList] = useState([]);
  const [userOfferList, setUserOfferList] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [userJobList, setUserJobList] = useState([]);
  const [userSchedule, setUserSchedule] = useState([]);
  const [fetchedReview, setFetchedReview] = useState([]);
  const [ready, setReady] = useState(false);

  const handleGeneratePdf = () => {
    profileRef.current.save();
  };

  useEffect(() => {
    fetch(
      `https://aps.songjukti.com/profile/login/api_freelancer/new_24/userPublicProfile.php?poster_id=${sopnoId}`
    )
      .then((res) => res.json())
      .then((result) => {
        setProfileDetails(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));

    fetch(
      `https://aps.songjukti.com/profile/login/api_service/new_24/expert_service_list.php?poster_id=${sopnoId}`
    )
      .then((res) => res.json())
      .then((result) => {
        setUserServiceList(result.slice(0, 6));
      })
      .catch((error) => console.log("ServiceApiError=> ", error));

    fetch(
      `https://aps.songjukti.com/profile/login/api_freelancer/new_24/expert_portfolio_allOwn.php?poster=${sopnoId}&poload=0&c_refer=`
    )
      .then((res) => res.json())
      .then((result) => {
        setPortfolios(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));

    fetch(
      `https://aps.songjukti.com/profile/login/api_freelancer/expert_job_list.php?poster_id=${sopnoId}`
    )
      .then((res) => res.json())
      .then((result) => {
        setUserJobList(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));

    fetch(
      `https://aps.songjukti.com/profile/login/api_freelancer/expert_schedule.php?poster_id=${sopnoId}`
    )
      .then((res) => res.json())
      .then((result) => {
        setUserSchedule(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));

    fetch(
      `https://aps.songjukti.com/profile/login/api_service/expert_offer_list.php?poster_id=${sopnoId}`
    )
      .then((res) => res.json())
      .then((result) => {
        setUserOfferList(result);
        // last of the six fetches to resolve in practice -- flips the
        // one orchestrated fade-in once the page has real content.
        setReady(true);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, [sopnoId]);

  useEffect(() => {
    const formData = new FormData();
    formData.append("page_refer", sopnoId);
    formData.append("action", "fetch");

    fetch(
      `https://aps.songjukti.com/profile/ac_rating/review_fetch_expert.php`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((result) => {
        setFetchedReview(result);
      })
      .catch((error) => console.log("ExpertApiError=> ", error));
  }, [sopnoId]);

  return (
    <PDFExport
      paperSize="A4"
      margin="0.5cm"
      scale={0.4}
      fileName={profileDetails.cname}
      ref={profileRef}
    >
      <Box sx={{ bgcolor: tokens.color.surfaceAlt, minHeight: "100vh", pb: 8 }}>
        {useChatBot(
          "personal",
          profileDetails.profile_pic,
          profileDetails?.agency_logo,
          profileDetails.cname,
          sopnoId,
          sopnoId
        )}

        <ProfileCard
          profileDetails={profileDetails}
          fetchedReview={fetchedReview}
          commesFrom={"personal"}
        />

        <Container sx={{ marginTop: "-60px", zIndex: 5, position: "relative" }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: `${tokens.radius.lg}px`,
              border: `1px solid ${tokens.color.line}`,
              boxShadow: tokens.shadow.md,
              bgcolor: tokens.color.surface,
            }}
          >
            <FloatingInfo
              profileDetails={profileDetails}
              handleGeneratePdf={handleGeneratePdf}
            />
          </Paper>
        </Container>

        <Fade in={ready} timeout={500}>
          <Container sx={{ mt: 5 }}>
            <Grid container spacing={4}>
              {/* Left rail: stays in view as the reader scrolls the
                  longer right-hand column, the way a résumé sidebar would. */}
              <Grid item xs={12} md={3.5}>
                <Stack
                  spacing={3}
                  sx={{
                    position: { md: "sticky" },
                    top: { md: tokens.space(11) },
                    alignSelf: "flex-start",
                  }}
                >
                  <PageReach profileDetails={profileDetails} />
                  <Accounts profileDetails={profileDetails} />
                  <BasicInfo profileDetails={profileDetails} />
                  <OfficeLocation profileDetails={profileDetails} />
                  <Schedule userSchedule={userSchedule} />
                  <Skills profileDetails={profileDetails} />
                </Stack>
              </Grid>

              <Grid item xs={12} md={8.5}>
                <Stack spacing={5} divider={<Divider sx={{ borderColor: tokens.color.line }} />}>
                  {userServiceList[0]?.service_refer && (
                    <Services serviceListData={userServiceList} />
                  )}
                  {userOfferList[0]?.service_refer && (
                    <Offers serviceListData={userOfferList} />
                  )}
                  {portfolios[0]?.pic_object[0]?.file_url && (
                    <Portfolios portfolio={portfolios} />
                  )}
                  {userJobList?.job_refer && <Jobs jobListData={userJobList} />}

                  {fetchedReview?.average_rating && (
                    <Review fetchedReview={fetchedReview} />
                  )}
                  {fetchedReview.review_data?.map(
                    (element) =>
                      element.type === "service" && (
                        <Reviewer
                          key={element.id ?? `${element.type}-${sopnoId}`}
                          refer={sopnoId}
                          fetchedReviewItem={element}
                          fetchedReviewList={fetchedReview.review_data}
                        />
                      )
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </Fade>
      </Box>
    </PDFExport>
  );
};

export default ProfileDetails;